"use client";

import { addVehicle } from "action/garage/addVehicle";
import { clearSelection } from "action/garage/clearSelection";
import { AMP_SELECT_VEHICLE_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import GarageDropdown from "component/garage-dropdown/garage-dropdown.component";
import VehicleSelectorForm from "component/vehicle-form/VehicleSelectorForm";
import { YEAR_MAKE_MODEL } from "component/vehicle-form/constants";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getVehicleName } from "util/helper/getVehicleName";
import { DEFAULT_FORMAT } from "util/helper/helper";
import isHomePage from "util/helper/isHomePage";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import PAImage from "../../../component/design-system/images/PAImage";
import styles from "./styles.module.scss";

function VehicleDescription(props) {
  const {
    isCompactGarage, onChangeVehicle, fitmentOptionsDetails = {}, fitmentOptionsPrompt = [],
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation(["category", "common"]);
  const { selectedVehicle } = useSelector((state: RootState) => state.garage);
  const { urlInformation } = useSelector((state: RootState) => state.utils);
  const router = useRouter();
  const { pathname } = router;
  const {
    tier0, tier1, tier2, tier3,
  } = urlInformation;

  const fitmentOptionKeys: string[] = Object.keys(fitmentOptionsDetails);
  const fitmentTitle = getVehicleName(selectedVehicle, DEFAULT_FORMAT, fitmentOptionKeys);
  const [nextAttribute] = fitmentOptionsPrompt || [];
  const fitmentOptionDetail = fitmentOptionsDetails[nextAttribute] || {};
  const { fitmentOptionValues = [] } = fitmentOptionDetail || {};

  const attributeTitle = fitmentOptionsDetails[nextAttribute]?.title;
  const [showFitmentDropdown, setShowFitmentDropdown] = useState(false);

  const vehicleDes = createVehicleDescription(selectedVehicle);
  const imageSize = isCompactGarage ? 45 : 60;

  const defaultVehicle = {
    ...{
      defaultMake: selectedVehicle?.make,
      defaultModel: selectedVehicle?.model,
      defaultYear: selectedVehicle?.year,
    },
  };
  const selectionOrder = YEAR_MAKE_MODEL;

  const selectFitmentHandler = () => {
    setShowFitmentDropdown(true);
  };
  return (
    <div className="d-flex flex-column">
      <div className={styles.vehicle_description_container}>

        <div className="d-flex justify-content-center">

          <PAImage
            width={imageSize}
            height={imageSize}
            fallback={createMakeImageSource()}
            alt={vehicleDes}
            src={createMakeImageSource(selectedVehicle)}
            className={styles.make_icon}
          />
        </div>

        <div className="flex-grow-1">

          <div className={styles.vehicle_description}>
            <div className={classNames("vehicle-description", {
              [styles.vehicle_heading]: isCompactGarage,
            })}
            >
              {vehicleDes}

            </div>
          </div>
          <HideIf show={selectedVehicle?.fitmentOptions && selectedVehicle.fitmentOptions.length > 0}>
            <PAText color="white" className="p-r-5" fontSize={FONT_SIZE[0]}>{fitmentTitle}</PAText>
          </HideIf>
          <HideIf show={tier1 && nextAttribute}>
            <HideIf show={nextAttribute && !showFitmentDropdown}>
              <span
                className={styles.engine_dropdown_button}
                onClick={selectFitmentHandler}
              >
                {t("select_vehicle_attribute", { attribute: attributeTitle || "" })}
              </span>
            </HideIf>
            <HideIf show={nextAttribute && showFitmentDropdown}>
              <div className="p-t-10">
                <VehicleSelectorForm
                  {...defaultVehicle}
                  selectionOrder={selectionOrder}
                  attributeOptions={fitmentOptionValues}
                  autoFocus
                  focusEl={nextAttribute}
                  category={{
                    tier0, tier1, tier2, tier3,
                  }}
                  onSelectVehicle={(newVehicle: any) => {
                    dispatch(addVehicle(newVehicle, true));
                  }}
                  attributeTitle={attributeTitle}
                />
              </div>
            </HideIf>

          </HideIf>
        </div>
      </div>
      <div className={styles.garage_dropdown}>
        <GarageDropdown
          dropdownId="dropdown-home-garage"
          buttonText={t("CHANGE VEHICLE")}
          onAddVehicleClick={() => dispatch(clearSelection())}
          menuFullWidth
          darkIcon
          loc={isHomePage(pathname) ? AMP_SELECT_VEHICLE_LOCATIONS.HOME_PAGE_BANNER : AMP_SELECT_VEHICLE_LOCATIONS.CATEGORY_PAGE_FILTER}
          onChangeVehicle={onChangeVehicle}
        />
      </div>
    </div>
  );
}

export default VehicleDescription;
